import * as React from 'react';
import { IIcon } from '../../interfaces/IIcon';
import { Icon } from '../Icon';

const style: React.CSSProperties = {
    fillRule: 'evenodd',
};

export function ArrowRightCircleIcon(props: IIcon) {
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={props.viewBox}
            style={props.style}
            className={props.className}
        >
            <path
                id="arrow_right_circle"
                d="M 8.862 6.724 L 18 12 L 8.862 17.276 L 8.862 6.724 Z"
                style={style}
                data-name="arrow down"
                strokeWidth="1"
                strokeLinejoin="round"
                strokeMiterlimit="3"
            />
        </Icon>
    );
}
